// extracted by mini-css-extract-plugin
module.exports = {"studyItems":"style-module__studyItems___3NEAp","finishedMessage":"style-module__finishedMessage___1yOB3"};